module.exports = __webpack_public_path__ + "img/10.3371b534.jpg";